import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons'
import { Box, Button, Collapse } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'
import { useReducer } from 'react'
import { EnteredOptionsCheckOutput } from '_app/types/api'
import { CartProductConfigurator } from './CartProductConfigurator'
import CartProductEngraving from './CartProductEngraving'
import CartProductOptions from './CartProductOptions'
import { ProductDetailsProps } from './ShowDetailsButton'

export const CartProductDetails = ({
  options,
  requiredOptions,
  cartItem,
  isDrawerMode,
}: ProductDetailsProps) => {
  const { t } = useTranslation()
  const [collapseDetails, toggleDetails] = useReducer(state => !state, false)
  const multiSizingOptions = requiredOptions?.filter(
    ({ options: reqOptions }) => reqOptions?.length > 1
  )
  const isItemHasWithoutPaintingOption =
    cartItem.entered_options?.option?.length === 1 &&
    cartItem.entered_options.option[0]?.value === 'bez malowania'
  const showProductOptions =
    options && cartItem.product.url_key && !isItemHasWithoutPaintingOption
  const showProductEngravingOptions = !!cartItem?.customizable_options?.length
  const displayButton = showProductOptions || showProductEngravingOptions
  const isConfiguratorProduct =
    cartItem.product.name && /^Lilou: #\d+$/.test(cartItem.product.name)
  if (!displayButton) {
    return null
  }
  return (
    <Box
      display="flex"
      flexDirection="column"
      {...(isDrawerMode
        ? {
            gridColumn: '1 / -1',
            mb: -4,
            borderTop: 'solid 1px',
            borderColor: 'borderLight',
          }
        : {
            m: { base: -4, lg: -6 },
            ml: 'auto',
            mt: { base: 4, lg: 6 },
            borderTop: 'solid 1px',
            borderColor: 'borderLight',
          })}
    >
      <Collapse in={collapseDetails} animateOpacity>
        <Box
          pl={isDrawerMode ? 2 : { base: 4, lg: 6 }}
          pr={isDrawerMode ? 0 : { base: 4, lg: 6 }}
          sx={{
            '&>div:not(:last-child)': {
              paddingBottom: 3,
              borderBottom: 'solid 1px',
              borderColor: 'borderLight',
            },
          }}
        >
           {showProductOptions && (
            <CartProductOptions
              cartItem={cartItem}
              options={options}
              requiredOptions={multiSizingOptions}
              currentUrlKey={cartItem?.product?.url_key}
            />
           )}
           {isConfiguratorProduct && (
            <CartProductConfigurator
              cartItem={cartItem}
              isDrawerMode={isDrawerMode}
            />
           )}
           {showProductEngravingOptions && (
            <CartProductEngraving
              enteredOptions={
                (cartItem?.entered_options?.option as EnteredOptionsCheckOutput[]) || []
              }
              customizableOptions={cartItem?.customizable_options || []}
              cartItem={cartItem}
              isDrawerMode={isDrawerMode}
            />
           )}
        </Box>
      </Collapse>

      <Button
        py={2}
        rightIcon={
          collapseDetails ? (
            <ChevronUpIcon w={6} h={6} />
          ) : (
            <ChevronDownIcon w={6} h={6} />
          )
        }
        aria-label="toggle details"
        onClick={toggleDetails}
        bg="none"
        color="black"
        fontSize="md"
        lineHeight={1.375}
        fontWeight="light"
        _hover={{
          bg: 'none',
          color: 'black',
        }}
        mb={isDrawerMode && collapseDetails ? 20 : 0}
        {...(isDrawerMode
          ? {
              justifyContent: 'space-between',
              padding: '0',
              pr: 0,
              pl: 8,
              borderTop: collapseDetails ? 'solid 1px' : 'none',
              borderColor: 'borderLight',
              borderBottom: 'solid 1px',
              borderBottomColor: 'borderLight',
            }
          : {})}
      >
        {collapseDetails ? t('HIDE_DETAILS') : t('SHOW_DETAILS')}
      </Button>
    </Box>
  )
}
